/*
 * General state enum can be used in any workflow.
 * Entries are not based on each other and could belong to different workflows that have nothing in common.
 * Translation-Key-Prefix: "priority."
 */
export enum Priority {

  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
  FALLBACK = 'FALLBACK',
}
